"use client";

import { trackEvent } from "@/lib/analytics/track";

// Thin client wrapper so server components (e.g. resume detail pages) can
// still fire a tracking event from a plain download link without becoming
// client components themselves.
export default function TrackedDownloadLink({
  event,
  metadata,
  onClick,
  ...anchorProps
}: { event: string; metadata?: Record<string, unknown> } & React.ComponentProps<"a">) {
  return (
    <a
      {...anchorProps}
      onClick={(e) => {
        trackEvent(event, metadata);
        onClick?.(e);
      }}
    />
  );
}
